<template>
  <app-page-wrapper v-if="data?.html" class="!max-w-[900px]" tag="aside">
    <div class="prose [&_h2]:font-title" v-html="data.html" />
  </app-page-wrapper>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";

const properties = defineProps<{
  course: CoursePageView;
}>();

const { data } = useLazyFetch(
  `/api/courses/${properties.course.slug}/seo-content`,
);

useSeoMeta({
  description: () =>
    data.value?.text ? `${data.value.text.slice(0, 250)}...` : undefined,
});
</script>
